// extracted by mini-css-extract-plugin
module.exports = {"xs":"Text_xs__3PRSt","sm":"Text_sm__1aiNk","md":"Text_md__15DD2","lg":"Text_lg__2fjim","xl":"Text_xl__duS9u"};